import './css/styles.scss';

const InitstegBlocket = function() {
      const blocks = document.querySelectorAll("[data-steps]");
  if (!blocks.length) return;

  const setState = (block, index) => {
    const steps = block.querySelectorAll("[data-step]");
    const total = steps.length;

    steps.forEach((el) => el.classList.remove("is-active"));
    const active = steps[index];
    if (!active) return;
    active.classList.add("is-active");


    const current = block.querySelector("[data-current]");
    if (current) current.textContent = String(index + 1);

    const prevBtn = block.querySelector("[data-prev]");
    const nextBtn = block.querySelector("[data-next]");

    if (prevBtn) {
        if (index === 0) {
            prevBtn.setAttribute("hidden", "hidden");
            prevBtn.disabled = true;
        } else {
            prevBtn.removeAttribute("hidden");
            prevBtn.disabled = false;
        }
        }


    if (nextBtn) {
      const isLast = index === total - 1;
      nextBtn.disabled = isLast;
      nextBtn.textContent = isLast ? "" : "Nästa steg";
    }

    block.dataset.index = String(index);

    // Fokus till rubrik (tillgängligt och skönt vid klick)
    const heading = active.querySelector(".step-title");
    if (heading) {
      //heading.setAttribute("tabindex", "-1");
      //heading.focus({ preventScroll: false });
      //heading.addEventListener("blur", () => heading.removeAttribute("tabindex"), { once: true });
    }
  };

  blocks.forEach((block) => {
    const steps = block.querySelectorAll("[data-step]");
    if (!steps.length) return;

    // Init
    setState(block, 0);

    block.querySelector("[data-prev]")?.addEventListener("click", () => {
      const i = Number(block.dataset.index || "0");
      setState(block, Math.max(0, i - 1));
    });

    block.querySelector("[data-next]")?.addEventListener("click", () => {
      const i = Number(block.dataset.index || "0");
      setState(block, Math.min(steps.length - 1, i + 1));
    });
  });
}

// on dom ready
// Make sure to call the function -.-'
document.addEventListener('DOMContentLoaded', () => {
	InitstegBlocket();
});
